import Colors from '@/constants/Colors';
import { ClockCircleTwoTone } from '@ant-design/icons';
import { Progress, Space, Tooltip } from 'antd';
import ProgressDetail from './ProgressDetail/ProgressDetail';
import {
  StyledProgressFeedback,
  StyledTooltipContent,
} from './ProgressFeedback.styled';
import useProgressFeedback from './useProgressFeedback.hook';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

export default function ProgressFeedback({
  repetitions,
  activityProgress,
  showCorrect,
  isStudent,
  isPreview,
  progressDetail,
  onlyGraph,
  dueDate,
  timeOffset = 0,
  size = '',
}) {
  let slotsLength = Number(repetitions) || 0;
  if (activityProgress?.progressSlots?.some((slot) => slot.isActive)) {
    slotsLength += 1;
  }

  const { state, actions } = useProgressFeedback({ isStudent });
  return !isPreview ? (
    <StyledProgressFeedback size={size}>
      <Space>
        {repetitions && !onlyGraph ? (
          <div className="repetitions">{`${repetitions} times `}</div>
        ) : null}
        <Space className="progress-slots">
          {[...Array(slotsLength)].map((_, i) => {
            const progressSlot = activityProgress?.progressSlots?.[i] || {
              progress: 0,
              correct: 0,
            };
            const lateProgress = doneLate(
              progressSlot.progressUpdatedAt,
              dueDate,
              timeOffset
            );
            const lateCorrect = doneLate(
              progressSlot.correctUpdatedAt,
              dueDate,
              timeOffset
            );
            return (
              <Tooltip
                className={`progress-slot-tooltip ${!isStudent && 'clickable'}`}
                title={
                  <StyledTooltipContent>
                    <div className="progress-value">
                      Progress: {progressSlot.progress}%
                    </div>
                    {showCorrect ? (
                      <div className="progress-value">
                        Correct: {progressSlot.correct}%
                      </div>
                    ) : (
                      ''
                    )}
                    {lateProgress || lateCorrect ? (
                      <div className="late-message">
                        {lateProgress ? <span>Done after due date</span> : null}
                        {lateCorrect ? (
                          <span>Improved after due date</span>
                        ) : null}
                      </div>
                    ) : null}
                  </StyledTooltipContent>
                }
                key={i}
              >
                <div
                  className="progress-wrapper"
                  onClick={(event) => {
                    if (!isStudent) {
                      event.preventDefault();
                      event.stopPropagation();
                      actions.showProgressDetail(true);
                    }
                  }}
                >
                  <Progress
                    className={`progress-slot ${
                      progressSlot.isActive ? 'active' : ''
                    }`}
                    type="dashboard"
                    gapDegree={30}
                    percent={progressSlot.progress}
                    success={{
                      percent: progressSlot.correct,
                      strokeColor: Colors.success,
                    }}
                    status="normal"
                    strokeWidth={25}
                    width={size == 'small' ? 25 : 50}
                    strokeLinecap="butt"
                    showInfo={false}
                    strokeColor={showCorrect ? Colors.red : Colors.text}
                  />
                  {(lateProgress || lateCorrect) && (
                    <ClockCircleTwoTone
                      twoToneColor={Colors.red}
                      className="out-of-date"
                    />
                  )}
                </div>
              </Tooltip>
            );
          })}
        </Space>
      </Space>
      {state.progressDetailVisible && !isStudent && (
        <ProgressDetail
          progressDetail={progressDetail}
          onClose={(event) => {
            event?.preventDefault();
            event?.stopPropagation();
            actions.showProgressDetail(false);
          }}
          dueDate={dueDate}
          timeOffset={timeOffset}
        />
      )}
    </StyledProgressFeedback>
  ) : null;
}

export function doneLate(date, dueDate, timeOffset) {
  return date
    ? dayjs
        .utc(date)
        .utcOffset(-timeOffset)
        .isAfter(dayjs(dueDate).endOf('day').utcOffset(-timeOffset, 1))
    : false;
}
